import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'
// import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn'
// import CheckCircleIcon from '@mui/icons-material/CheckCircle'
// import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import DeviceConnection from '../components/DeviceConnection'

// import { Button, Paper, Snackbar } from '@mui/material'
// import Text from '../components/Text'

export default function HomePage() {
  const theme = useTheme()

  return (
    <LayoutBase>
      <LayoutMain>
        <div className="relative w-full pb-14">
          <div
            className={clsx('absolute top-0 left-0 w-full h-[400px] ', {
              'bg-opacity-[0.05] bg-white': theme.isDark,
              'bg-opacity-[0.05] bg-gray-500': !theme.isDark
            })}
          />
          <div
            className={clsx('absolute top-0 left-0 w-full h-[550px]', {
              'bg-opacity-[0.05] bg-white': theme.isDark,
              'bg-opacity-[0.05] bg-gray-500': !theme.isDark
            })}
          />
          <div className="relative py-12 md:pb-14">
            <div className="mx-auto w-full md:max-w-[1300px] px-2 md:px-12">
              <DeviceConnection />
            </div>
          </div>
        </div>
      </LayoutMain>
    </LayoutBase>
  )
}
